import functions from '../../../../../world/spa/libs/vuexFunctions';

export default {
    namespaced: true,
    state: {
        objs: []
    },
    getters: {
        ...functions.createDefaultGetters(['idWorldBankAccount'])
    },
    mutations: {
        ...functions.createDefaultMutations(['idWorldBankAccount'])
    },
    actions: {
        ...functions.createDefaultActionsWithStore(['idWorldBankAccount'])
    },
}